export const getCurrentTimeInSeconds = () => Math.floor(new Date().getTime() / 1000);
